/**
 * Wishlist Page - Display saved wishlist items
 */

import {
  ContentBlock,
  Box,
  IconHeart,
  Stack,
  Button,
  IconDelete,
} from 'braid-design-system';
import type React from 'react';
import { useState } from 'react';
import { Link } from 'react-router';

import {
  ItemListing,
  type ListingViewMode,
} from '../../components/ItemListing/ItemListing';
import { PageHead } from '../../components/PageHead/PageHead';
import { useWishlist } from '../../context/WishlistContext';

import * as styles from './Wishlist.css';

export const Wishlist: React.FC = () => {
  const { items, clearWishlist, removeFromWishlist } = useWishlist();
  const [viewMode, setViewMode] = useState<ListingViewMode>('grid');

  return (
    <ContentBlock width="large">
      <PageHead
        title="Wishlist"
        description="Your saved fairy garden treasures from Fae Forest."
        path="/wishlist"
        noIndex
      />
      <Box paddingY="large">
        <Stack space="large" align="center">
          <Stack space="small" align="center">
            <h1 className={styles.title}>My Wishlist</h1>
            <p className={styles.subtitle}>Your saved fairy garden treasures</p>
          </Stack>

          {items.length === 0 ? (
            <Box
              borderRadius="large"
              maxWidth="medium"
              padding="large"
              style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}
            >
              <Stack space="small" align="center">
                <Box>
                  <IconHeart size="large" />
                </Box>
                <h2 className={styles.emptyTitle}>Your wishlist is empty</h2>
                <p className={styles.emptyText}>
                  Start adding items you love by clicking the heart on any
                  product
                </p>
                <Link to="/products" className={styles.browseButton}>
                  Browse Products
                </Link>
              </Stack>
            </Box>
          ) : (
            <>
              <ItemListing
                products={items}
                viewMode={viewMode}
                onViewModeChange={setViewMode}
                listActions={(product) => (
                  <button
                    type="button"
                    className={styles.removeButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFromWishlist(product.id);
                    }}
                  >
                    Remove
                  </button>
                )}
              >
                <p className={styles.itemCount}>
                  {items.length} {items.length === 1 ? 'item' : 'items'} saved
                </p>
              </ItemListing>

              <div style={{ textAlign: 'center' }}>
                <Button
                  variant="solid"
                  tone="critical"
                  size="small"
                  icon={<IconDelete />}
                  onClick={clearWishlist}
                >
                  Clear Wishlist
                </Button>
              </div>
            </>
          )}
        </Stack>
      </Box>
    </ContentBlock>
  );
};
